<?php

\Core\View::$template = function () {

    $html = '';
    $pv = \Core\View::$page_vars;
    \ISOPHP\js_core::$console->log('pagevars: ', $pv);
    $rqd = $pv['request_data']['employer_detail'];

    $html = '<div class="col-sm-12">
                    <div class="col-sm-1">
                        &nbsp
                    </div>
                    <div class="col-sm-10 one_account" id="job_1">
                        <div class="col-sm-12">
                            <div class="col-sm-2">
                                <div class="col-sm-12">
                                    <h5 class="job_id_title">Employer ID #</h5>
                                </div>
                                <div class="col-sm-12">
                                    <h3 class="job_id">' . $rqd['id'] . '</h3>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="col-sm-12">
                                    <h5 class="job_title_title">Full Name</h5>
                                </div>
                                <div class="col-sm-12">
                                    <h3 class="job_title">' . $rqd['full_name'] . '</h3>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="col-sm-12">
                                    <h5 class="job_description_title">Company Name</h5>
                                </div>
                                <div class="col-sm-12">
                                    <h3 class="job_description">' . $rqd['company_name'] . '</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-1">
                        &nbsp;
                    </div>
                 </div>';

    return $html;

};


// WEBPACK FOOTER //
// app/JobList/View/EmployerDetails.php